import { initSliders } from 'components/swiper-init/index';

import './index.scss';

const blockSliderPosts = () => {
	initSliders('.block-slider-posts .slider-content .swiper');
};

export default blockSliderPosts;
